import { useState } from "react";
import { createUseStyles } from "react-jss";
import produce from "immer";
import RedButton from "../../refresh/RedButton";
import SidebarLightbox from "../../refresh/SidebarLightbox";
import TextInput from "../../refresh/inputs/TextInput";
import GenericOptions from "../GenericOptions";
import styles from "./sharedStyles";
import Checkbox from "../../refresh/inputs/Checkbox";

const useStyles = createUseStyles(styles);

const EditExternalHotspot = ({
  show,
  hotspot,
  onClose,
  onComplete,
  account,
  isLink,
  setLink,
  template,
}) => {
  const classes = useStyles();
  const [config, setConfig] = useState(
    produce(hotspot, draft => {
      draft.options.display ??= "external";
    }),
  );

  return (
    <SidebarLightbox
      show={show}
      onClose={onClose}
      sidebar={
        <>
          <h1 className={classes.title}>
            Edit External Link {template && "Template"}
          </h1>
          <p className={classes.subtitle}>
            Link to an external website. This can either be a direct link that
            opens in a new tab, or as a lightbox
          </p>
          <div className={classes.grow} />
          {!template && (
            <Checkbox sidebar value={isLink} onChange={setLink}>
              Show in Links menu
            </Checkbox>
          )}
        </>
      }
    >
      <div className={classes.options}>
        <GenericOptions
          icon="Link"
          config={config}
          setConfig={setConfig}
          account={account}
          title={false}
          template={template}
        />
        <hr />
        <TextInput
          label="url"
          required
          value={config.options?.url || ""}
          onChange={url =>
            setConfig(
              produce(draft => {
                draft.options.url = url;
              }),
            )
          }
        />
        <Checkbox
          value={config.options.display === "lightbox"}
          onChange={lightbox =>
            setConfig(
              produce(draft => {
                draft.options.display = lightbox ? "lightbox" : "external";
              }),
            )
          }
        >
          Display as lightbox (currently:{" "}
          {config.options.display === "lightbox"
            ? "lightbox"
            : "open in new tab"}
          )
        </Checkbox>
        <RedButton
          disabled={!(config.tooltip && config.options?.url)}
          onClick={() => onComplete(config)}
        >
          Save
        </RedButton>
      </div>
    </SidebarLightbox>
  );
};

export default EditExternalHotspot;
